import {
  Button,
  Form,
  Icon,
  ICONS,
  PhoneNumberInput,
  PLATFORM_THEME_COLORS,
  Separator,
  TextInput,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import {
  DeleteContainer,
  ContactPersonsListContent,
  FieldsWrapper,
  ButtonWrapper,
} from './contact-persons-list.styles';

const ContactPersonsList = ({ t, isEdit }: { t: Function; isEdit?: boolean }) => (
  <>
    <Form.List name="contactPersons">
      {(fields, { add, remove }) => (
        <ContactPersonsListContent
          isFirstItem={fields.length > 0}
          isBtn={!isEdit && fields.length < 1}
        >
          {fields.length > 0 && (
            <Typography
              fontColor={
                isEdit
                  ? PLATFORM_THEME_COLORS.grayVariations.dark
                  : PLATFORM_THEME_COLORS.primary.black
              }
              weight="bold"
            >
              {t('customers:labels.contactPerson')}
            </Typography>
          )}
          <div>
            {fields.map(field => (
              <FieldsWrapper key={field.key} isEdit={isEdit}>
                <div>
                  <div>
                    <DeleteContainer>
                      <Form.Item
                        name={[field.name, 'name']}
                        label={t('customers:labels.name')}
                        rules={[
                          {
                            required: true,
                            message: t('customers:error.contactPersonNameRequired'),
                          },
                        ]}
                      >
                        <TextInput maxLength={50} placeholder="Georia Young" />
                      </Form.Item>

                      <Icon
                        icon={ICONS.trash}
                        color={PLATFORM_THEME_COLORS.tone.red}
                        size={22}
                        rightMargin={false}
                        onClick={() => remove(field.name)}
                      />
                    </DeleteContainer>
                    <Form.Item
                      name={[field.name, 'phoneNumber']}
                      label={t('customers:labels.mobilePhoneNumber')}
                      rules={[
                        { required: true, message: t('customers:error.mobilePhoneNumberRequired') },
                      ]}
                    >
                      <PhoneNumberInput placeholder="017612345678" />
                    </Form.Item>
                  </div>
                  <ButtonWrapper isLast={field.name === fields.length - 1}>
                    <Form.Item
                      name={[field.name, 'email']}
                      label={t('common:labels.email')}
                      rules={[
                        { type: 'email', message: t('common:validation.error.incorrectFormat') },
                      ]}
                    >
                      <TextInput maxLength={50} placeholder="georgia.young@example.com" />
                    </Form.Item>
                    {field.name === fields.length - 1 && (
                      <Button
                        type="text"
                        icon={ICONS.plus}
                        iconColor={PLATFORM_THEME_COLORS.primary.blue}
                        onClick={() => add()}
                      >
                        {t('customers:buttons.addContactPerson')}
                      </Button>
                    )}
                  </ButtonWrapper>
                </div>
                {isEdit && <Separator />}
              </FieldsWrapper>
            ))}
          </div>
          {!isEdit && fields.length < 1 && (
            <Button
              type="text"
              icon={ICONS.plus}
              iconColor={PLATFORM_THEME_COLORS.primary.blue}
              onClick={() => add()}
            >
              {t('customers:buttons.addContactPerson')}
            </Button>
          )}
        </ContactPersonsListContent>
      )}
    </Form.List>
  </>
);

export default ContactPersonsList;
